<div class="container section-gap">
  <div class="row">
    <div class="col-lg-6 col-sm-12 col-xs-12">
        <div class="row chart" #panel>
                <kla-single-donut  *ngIf="showChart" id="{{chartConfig.id}}" [config]="chartConfig" [width]="chartConfig.width" [chartAltText]="config.chartAltText"></kla-single-donut>
                </div>
      <div class="footer-paragraph" *ngIf="config.title.footer">
        <app-dynamic-content
          [contentId]="'single-donut-image-title'"
          [htmlContent]="config.title.footer">
        </app-dynamic-content>
      </div>
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <kla-title [component]="config.image" [lineConfig]="lineConfig" [config]="config.title" [showFooter]="false"></kla-title>
    </div>

  </div>
</div>
